import React from 'react'
import {FormGroup, Input} from 'reactstrap'
import ReactTooltip from 'react-tooltip'

export default class OptionalsBox extends React.Component {
    constructor(props) {
        super(props)
        const obj = {}
        this.props.optionals.map(o => obj[o.id] = o.quantity || (!this.props.edit && localStorage.getItem(o.id)) || 0)
        this.state = {...obj}
    }

    onNumberChange = (optional, value) => {
        this.setState({[optional]: value})
        !this.props.edit && localStorage.setItem(optional, value)
    }
    onCheck = (optional, checked) => {
        const value = checked && (this.state[optional] && (+this.state[optional]) || 1) || 0
        this.setState({[optional]: value})
        !this.props.edit && localStorage.setItem(optional, value)
    }

    toQueryString(paramsObject) {
        return Object
            .keys(paramsObject)
            .map(key => `${key}:${paramsObject[key]}`)
            .join('-')

    }

    selectedValues = () => {
        return this.toQueryString(this.state)
    }

    renderTooltip = tooltip => <i className="fa fa-info-circle text-primary ml-1" style={{fontSize: 16}} data-tip={tooltip}/>

    renderOptionals() {
        return this.props.optionals.map(optional => {
            const quantity = +this.state[optional.id] || 0
            const units = quantity > 0 ? (quantity - (optional.is_special ? 1 : 0)) : 1
            const selected = this.state[optional.id] || 0
            return (
                <div className={'row m-0 mb-2'} key={optional.id}>
                    <div className={'col mb-3'}>
                        <div className={'divDot'}>
                            <FormGroup check className={'mb-2'}>
                                <Input type="checkbox" value={optional.id}
                                       onChange={(e) => this.onCheck(optional.id, e.target.checked)}
                                       checked={this.state[optional.id] && +this.state[optional.id] > 0}
                                />{' '}
                            </FormGroup>
                            {optional.name}
                            {optional.is_special &&
                            <span className={'text-success font-weight-600 ml-1'}>(1 {this.props.t.o_free})</span>
                            }
                            {optional.tool_tip && this.renderTooltip(optional.tool_tip)}
                        </div>
                    </div>
                    <div className={'col-12 col-md-6 col-lg-4 col-xl-3'}>
                        <div className="row">
                            <div className="col-6 col-sm-9 col-md-6 col-lg-5">
                                <Input type="select" name="select" className="pull-right"
                                       onChange={(e) => this.onNumberChange(optional.id, e.target.value)}
                                       style={{padding: 0, marginTop: -5, width: 40}}
                                       value={selected}
                                    >
                                    <option>0</option>
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                </Input>
                            </div>
                            <div className={'col pl-0 text-right text-nowrap' + (quantity > 0 ? '' : ' text-muted')}>
                                {units * optional.daily_cost}&euro;/{optional.daily && this.props.t.i_day || this.props.t.o_period}
                            </div>
                        </div>
                    </div>
                </div>
            )
        })
    }

    render() {
        return (
            <div className={'bg-white rounded border mb-4 py-2'}>
                <ReactTooltip className='r-tooltip' />
                <div className="d-flex align-items-center px-3 mb-1">
                    <div className="h2 mr-3"><i className={'fa fa-edit text-primary'}/></div>
                    <div className="h5 mr-3">{this.props.t.o_title}</div>
                </div>
                {this.renderOptionals()}
            </div>
        )
    }
}